import React from 'react';
import routes from '../../../routes/routes';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import styled from 'styled-components';
import { MQS } from '../constants/styles';

const Head = styled.h1<{ isCancelMembership: boolean }>`
    font-size: 1.75rem;
    font-weight: 400;
    margin: 18px auto 26px 0;
    @media (max-width: ${MQS.mq2Max}) {
        display: ${({ isCancelMembership }) => (isCancelMembership ? 'initial' : 'none')};
    }
`;

const HeadTitle: React.FC = () => {
    const currentPath = window.location.pathname.substring(process.env.PUBLIC_URL.length);
    const isCancelMembership = currentPath === '/account-security/delete';
    const currentTitleId = isCancelMembership
        ? 'cancel.membership.link'
        : routes.find((route) => route.path === currentPath)?.name.id;

    return (
        <>
            {currentTitleId && (
                <Head isCancelMembership={isCancelMembership}>
                    {TranslationHelpers.getFormattedMessage(currentTitleId)}
                </Head>
            )}
        </>
    );
};

export default HeadTitle;
